import template from './emailBodyField.html';
import controller from './emailBodyFieldCtrl.js';

export default {
  template,
  controller,
  controllerAs: 'vm',
  bindings: {
    body: '<',
    onUpdate: '&',
  },
};
